<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="assessment-share">
                <v-layout row wrap class="page-content">
                    <v-flex xs12 align-start class="no-padding-bottom no-padding-left" >
                        <h2 class="page-title">{{text("api.share.page.title")}}</h2>
                    </v-flex>
                </v-layout>

                <v-layout row wrap class="assessment-share-page">
                    <v-flex xs12 sm4 class="no-padding">
                        <v-card class="assessment-share-page-btns" v-if="getSummaryDataNew">
                            <v-card-text>
                                <div>
                                    <h5>
                                        {{text("api.share.page.assessment.data.headline")}}
                                    </h5>
                                    <span>{{getSummaryDataNew.assessmentToken}} - {{getSummaryDataNew.assessmentDateNew}} {{getSummaryDataNew.assessmentTimeNew}}</span>
                                </div>
                                <div>
                                    <h5>
                                        {{text("api.share.page.main.symptom.headline")}}
                                    </h5>
                                    <span>{{getSummaryDataNew.mainSymptom}}</span>
                                </div>
                                <div v-if="getSummaryDataNew.relatedSymptomList">
                                    <h5>
                                        {{text("api.share.page.related.symptoms.headline")}}
                                    </h5>
                                    <span v-for="relatedSymptom in getSummaryDataNew.relatedSymptomList">{{relatedSymptom}}<br /></span>
                                </div>
                                <div>
                                    <h5>
                                        {{text("api.assessment.headline.di1")}}
                                    </h5>
                                    <span>{{getSummaryDataNew.decisionItem1}}</span>
                                </div>
                                <div v-if="getSummaryDataNew.decisionItem2 != null">
                                    <h5>
                                        {{text("api.assessment.headline.di2")}}
                                    </h5>

                                    <span style="display: inline-flex">
                                        <span v-if="getSummaryDataNew.target === true" style="position: relative; right: 3px; bottom: 2px;">
                                            <WarningIcon></WarningIcon>
                                        </span>
                                         <span>{{getSummaryDataNew.decisionItem2}}</span>
                                    </span>
                                </div>

                                <div class="share-btns">
                                    <!--
                                    NOTE:
                                    `style="{'border-color': ...}` binding on each sharing channel icon is needed for
                                    Internet Explorer. The border won't be shown without it, because IE doesn't know
                                    what `--var` is and `--var()` is used to set the value of `border-color` attribute
                                    in ".border-primary-color" class.
                                    (For further investigation, search "cssProps" in App.vue, "$color-brand-primary"
                                    in _variables.scss and "border-primary-color" in global.scss.)
                                    -->
                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('PDF') > -1"
                                         @click="printPdfTemplate()"
                                         :class="{'border-primary-color': isPdfTemplateListActive}"
                                         :style="{'border-color': (isPdfTemplateListActive ? getCurrentGuiThemeColor : 'transparent')}"
                                         class="share-icon">
                                        <pdf-icon-svg></pdf-icon-svg>
                                    </div>

                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('EMAIL') > -1"
                                         @click="sendEmail()"
                                         :class="{'border-primary-color': isEmailFormActive}"
                                         :style="{'border-color': (isEmailFormActive ? getCurrentGuiThemeColor : 'transparent')}"
                                         class="share-icon">
                                        <email-icon-svg></email-icon-svg>
                                    </div>

                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('TRANSLATE') > -1"
                                         @click="showTranslatePdfForm()"
                                         :class="{'border-primary-color': isTranslatePdfFormActive}"
                                         :style="{'border-color': (isTranslatePdfFormActive ? getCurrentGuiThemeColor : 'transparent')}"
                                         class="share-icon">
                                        <translate-pdf-icon></translate-pdf-icon>
                                    </div>

                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('THREEMA') > -1"
                                         @click="sendPDFMessage()"
                                         :class="{'border-primary-color': isPhoneFormActive}"
                                         :style="{'border-color': (isPhoneFormActive ? getCurrentGuiThemeColor : 'transparent')}"
                                         class="share-icon">
                                        <threema-icon-svg></threema-icon-svg>
                                    </div>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm8 class="no-padding">

                        <!-- Begin SEND EMAIL FORM -->
                        <v-card class="assessment-share-page-btn-action popup-scoring sendAssessment popup-scoring-assessment"
                                v-if="mustShowSendAssessmentPopup || isEmailFormActive">
                            <v-card-title class="headline ">
                                <span class="font-weight-bold">{{text('db.global.TYPE_GTS_SUMMARY_TITLE_D')}}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-form v-model="valid" ref="form">
                                    <v-flex xs12 sm12 class="no-padding-left">
                                        <v-text-field
                                            v-model="email"
                                            solo
                                            :placeholder="text('api.summary.communication.summary.mail')"
                                            :rules="emailRules"
                                            clearable
                                            ref="EMAIL_FIELD"
                                        ></v-text-field>
                                        <br />
                                        <v-checkbox ref="CHECKBOX_COPY_FIELD"
                                                    v-model="checkbox"
                                                    :label="text('api.summary.communication.summary.link')"
                                                    color="primary"
                                                    class="send-copy-section">
                                        </v-checkbox>
                                        <p v-if="sentFlag" class="successfulSent">{{ text('api.scoring.send.popup.text') }}</p>
                                    </v-flex>
                                    <v-flex xs6 v-if="!getIsAssessmentSealed && currentRouteName === 'ScoringPage'">
                                        <span class="font-weight-light text-sealed">{{text('api.scoring.sealed.send.popup.text')}}</span>
                                    </v-flex>
                                </v-form>

                            </v-card-text>

                            <v-card-actions>
                                <v-btn class="color-on-primary-text" v-if="!sentFlag" @click="sendAssessment(), setSentFlagFalse()" :disabled="valid === false" color="primary">{{text('api.button.send')}}</v-btn>
                                <v-btn class="color-on-primary-text" v-if="!sentFlag" @click="sendAssessmentPushHome()" :disabled="valid === false" color="primary">{{text('api.button.send.and.close')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                        <!-- End SEND EMAIL FORM -->


                        <!-- Begin PDF TEMPLATE SELECTION (Pdf template list) -->
                        <v-card class="assessment-share-page-btn-action popup-scoring sendAssessment popup-scoring-assessment pdf-template-list-container"
                                v-if="isPdfTemplateListActive">
                            <v-card-title class="headline ">
                                <span class="font-weight-bold">{{text('pdf.template.selectToDownload')}}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-flex xs12 sm12 class="no-padding-left">
                                    <div class="pdf-template-list">

                                        <div v-for="template in getPdfTemplateList">
                                            <v-btn @click="startPrintPdf(template)" class="btn btn--flat btn-pdf-template-name">{{findTemplateNameForDisplay(template)}}</v-btn>
                                        </div>

                                    </div>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                        <!-- End PDF TEMPLATE SELECTION (Pdf template list) -->


                        <!-- Begin TRANSLATE PDF -->
                        <translate-pdf-form :is-visible="isTranslatePdfFormActive"
                                            @onDownloadPdf="startPrintPdf($event.pdfTemplate, $event.languageKey)"></translate-pdf-form>
                        <!-- End TRANSLATE PDF -->


                        <!-- Begin PDF MESSAGE (THREEMA) -->
                        <send-pdf-message-form
                            :is-visible="isPhoneFormActive"
                            :loading="loading"
                            :api-error="(phoneRecipientInvalid ? text('pdf.message.recipient.not.available') : '')"
                            @onClickSendBtn="startSendPDFMessage"
                            @onClickSendAndCloseBtn="startSendPdfMessagePushHome"
                            @onChangeRecipient="phoneRecipientInvalid = false"
                        ></send-pdf-message-form>
                        <!-- End PDF MESSAGE (THREEMA) -->

                    </v-flex>
                </v-layout>
            </div>
        </v-container>


        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex xs12 class="summary-page-btns">

                    <div v-if="referrerUrlParam === 'summary'" class="footer-right-btns">
                        <v-btn @click="goToPreviousUrl" class="footer-btn" flat>
                            <arrow-left-icon />
                            {{ text('api.button.back') }}
                        </v-btn>
                    </div>
                    <div v-else class="footer-right-btns">
                        <v-btn @click="goToScoringPage" class="footer-btn" flat>
                            <arrow-left-icon />
                            {{ text('api.button.back') }}
                        </v-btn>
                        <v-btn v-if="!getUserData.embedded" to="/home" class="footer-btn home" color="primary">
                            {{text("api.button.newCase")}}
                        </v-btn>
                    </div>

                </v-flex>
            </v-layout>
        </v-footer>

        <code-popup></code-popup>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import HeaderBar from '../shared/HeaderBar';
import CodePopup from '../../../common/components/shared/ActivationCodePopup';
import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
import Vue from "vue"; // need this to use the plugin methods
import pdfIconSvg from "../../../common/components/svg/shared/pdfIcon";
import emailIconSvg from "../../../common/components/svg/shared/emailIcon";
import threemaIconSvg from "../../../common/components/svg/shared/threemaIcon";
import translatePdfIcon from "../../../common/components/svg/shared/translatePdfIcon";
import TranslatePdfForm from "./forms/TranslatePdfForm";
import SendPdfMessageForm from "./forms/SendPdfMessageForm";

import axios from "axios";
import ArrowLeftIcon from "../../../common/components/svg/shared/arrowLeftIcon";
import WarningIcon from "../../../common/components/svg/shared/warningIcon.vue";

export default {
        name: 'AssessmentSharePage',
        components: {
            WarningIcon,
            ArrowLeftIcon,
            HeaderBar,
            CodePopup,
            AcceptCookie,
            DetectBrowserCookie,
            pdfIconSvg,
            emailIconSvg,
            threemaIconSvg,
            translatePdfIcon,
            TranslatePdfForm,
            SendPdfMessageForm,
        },

        data () {
            return {
                valid: false,
                loading: false,
                email: '',
                phoneRecipientInvalid: false,
                checkbox: false,
                items: [
                    {
                        src: 'static/img/in4medicine_logo.svg',
                        title: 'in4medicine',
                        description: 'Medizin und Informatik - ein starkes Team.'
                    }
                ],
                emailRules: [
                    (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                    (value) => {
                        let regex = /^(([a-zA-Z0-9_\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-.]+)@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-]+\.)+))([a-zA-Z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{2,15}|[0-9]{1,3})(]?)(\s*\040\s*|\s*$))*$/;
                        return regex.test(value) || this.text("api.error.email.invalid");
                    }
                ],
                isEmailFormActive: false,
                isPdfTemplateListActive: false,
                isPhoneFormActive: false,
                isTranslatePdfFormActive: false,
                checkBoxPlugin: Vue.CheckBox.checkBoxSvg,
                referrerUrlParam: "" // Where are we coming from? :)
            }
        },

        beforeCreate() {
            // Reset stores.
            this.$store.commit('ProductListStore/resetStore');
            this.$store.commit('AssessmentStartStore/resetStore');
            this.$store.commit('ChooseMainSymptomStore/resetStore');
            this.$store.commit('SymptomsQuestionsStore/resetStore');
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('ScoringStore/resetStore');
            this.$store.commit('SummaryStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');
        },

        created () {

            if (typeof this.$route.query.referrer !== "undefined") {
                this.referrerUrlParam = this.$route.query.referrer;
            }

            // Load product list data from server.
            //  this.$store.dispatch('ProductListStore/loadProductListPageData');
            if (this.getAssessmentToken !== null) {
                let requestParams = {
                    assessmentToken: this.getAssessmentToken,
                    assessmentVersion: this.getAssessmentVersion
                };
                if (this.readMsitatValue !== null) {
                    requestParams.msitat = this.readMsitatValue;
                }
                this.$store.dispatch('AssessmentShareStore/loadAssessmentData', requestParams);
            }
        },

        computed: {
            ... mapGetters({
                getUserData: 'UserStore/getUserData',
                getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
                sentFlag: 'ScoringStore/getAssessmentSent',
                getIsAssessmentSealed: 'ScoringStore/getIsAssessmentSealed',
                datasummary: 'SummaryStore/getSummaryDataNew',
                mustShowSendAssessmentPopup: 'ScoringStore/getMustShowSendAssessmentPopup',
                getSummaryDataNew: 'AssessmentShareStore/getSummaryDataNew',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray',
                getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor'
            }),
            currentRouteName() {
                return this.$route.name;
            },
            getAssessmentToken() {
                return sessionStorage.getItem('proAssessmentToken');
            },
            getAssessmentVersion() {
                let assessmentVersion = 1; // By default, use 1 (only if no other assessmentVersion is found in sessionStorage).
                if (sessionStorage.getItem('proAssessmentVersion') !== null) {
                    assessmentVersion = sessionStorage.getItem('proAssessmentVersion');
                }
                return assessmentVersion;
            },
            readMsitatValue() {
                return sessionStorage.getItem('proMsitatForAssessmentShare'); // If "proMsitatForAssessmentShare" key is not found in sessionStorage, NULL will be returned.
            },
            getPdfTemplateList() {
                return this.getAppPropertyValueArray('PDF_TEMPLATE');
            },
            findTemplateNameForDisplay() {
                return (template) => {
                    return (this.text('pdf.template.name.' + template).length > 0)
                        ? this.text('pdf.template.name.' + template)
                        : template;
                };
            }
        },
        methods: {
            ...mapActions({
                showActivationCodePopup: 'ProductListStore/showActivationCodePopup',
                showSendAssessmentPopup: 'ScoringStore/showSendAssessmentPopup',
            }),

            hideTestPopup() {
                this.$store.commit('ProductListStore/setMustShowActivationCodePopup', false);
            },

            sendPDFMessage(){
                this.isEmailFormActive = false;
                this.isPdfTemplateListActive = false;
                this.isTranslatePdfFormActive = false;
                this.isPhoneFormActive = !this.isPhoneFormActive;
                this.$store.commit('ScoringStore/setMustShowSendAssessmentPopup', false );
            },

            startSendPDFMessage(params){

                this.loading = true;

                let requestParams = this.buildParamsForPdfCreation({
                    recipient: params.recipient,
                    userAgrees: params.userAgrees,
                    template: params.template,
                    // translationLanguage "or" = Original Language of the assessment
                    translationLanguage: (params.translationLanguage === "or") ?
                        "" : params.translationLanguage

                });

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/deliverPDFMessage', requestParams);

                axiosRequest
                    .then((response) => {
                        if (typeof response.data.returnCode !== "undefined"
                                && response.data.returnCode === 240) {
                            this.phoneRecipientInvalid = true;
                            this.valid = false;
                        } else {
                            this.phoneRecipientInvalid = false;
                            this.setSentFlag();
                            this.setSentFlagFalse();
                        }
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.log(error);
                    });

            },

            startSendPdfMessagePushHome(params){
                this.startSendPDFMessage(params);
                    console.log("aasdasd")
                    let that = this;
                    setTimeout(function() {
                        if(!that.phoneRecipientInvalid){
                            that.$router.push('/home');
                        }
                    }, 1000);
            },

            printPdfTemplate() {

                if (this.getAppPropertyValueArray('PDF_TEMPLATE').length === 0) {
                    this.startPrintPdf();
                }
                else if (this.getAppPropertyValueArray('PDF_TEMPLATE').length === 1) {
                    this.startPrintPdf(this.getAppPropertyValueArray('PDF_TEMPLATE')[0]);
                }
                else if (this.getAppPropertyValueArray('PDF_TEMPLATE').length > 1) {
                    this.togglePdfTemplateList();
                }
            },

            showTranslatePdfForm() {
                this.isEmailFormActive = false;
                this.isPdfTemplateListActive = false;
                this.isPhoneFormActive = false;
                this.$store.commit('ScoringStore/setMustShowSendAssessmentPopup', false);
                this.isTranslatePdfFormActive = !this.isTranslatePdfFormActive;
            },

            togglePdfTemplateList() {
                this.isEmailFormActive = false;
                this.isPhoneFormActive = false;
                this.isTranslatePdfFormActive = false;
                this.$store.commit('ScoringStore/setMustShowSendAssessmentPopup', false);
                this.isPdfTemplateListActive = !this.isPdfTemplateListActive;
            },
            handlePdfTemplateSelected(pdfTemplate) {
                this.startPrintPdf(pdfTemplate);
            },

            /**
             * Immediately download a PDF file containing the assessment data.
             * @param pdfTemplate {String} (optional)
             * @param languageKey {String} (optional) - Language. Used for PDF translation.
             */
            startPrintPdf(pdfTemplate, languageKey){

                let requestParams = this.buildParamsForPdfCreation({
                    template: pdfTemplate,
                    translationLanguage: languageKey,
                });

                let axiosRequest = axios.post(
                    process.env.API_BASE_URL + '/assessment/deliverPDF',
                    requestParams,
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/pdf'
                        }
                    }
                );

                axiosRequest.then((response) => {

                    const attachment_name = response.headers["attachement-file-name"];

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), decodeURIComponent(attachment_name)); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        if (attachment_name == null || attachment_name == ""){
                            link.setAttribute('download', "assessment_case.pdf"); //or any other extension
                        }
                        else{
                            link.setAttribute('download', decodeURIComponent(attachment_name)); //or any other extension
                        }

                        document.body.appendChild(link);
                        link.click();
                    }
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            /**
             * @TODO:
             * Consider moving this method to a separate file (ex. a Vue plugin, something like AssessmentSharePlugin.js,
             * for example), because maybe we can include it in PFI Share Assessment page and use the same method
             * there as well, in order to reduce code duplication. And maybe we can do the same thing with other functions,
             * for ex. `startPrintPdf()` and/or `startSendPDFMessage()`.
             */
            buildParamsForPdfCreation(additionalParams){

                // ----- Default params/values. -----
                let requestParams = {
                    assessmentToken: null,
                    assessmentVersion: null,
                    template: '', // If no template name is passed, the API will use the default template.
                    decisionItem1Label: null,
                    decisionItem1Color: null,
                    decisionItem2Label: null,
                    decisionItem2Icon: null,
                    decisionText: "",
                    disclaimer1: "",
                    disclaimer2: ""
                };

                // ----- Assessment params. -----
                if (typeof this.$route.query.assessmentId !== "undefined") {
                    requestParams.assessmentToken   = this.datasummary.overview.assessmentToken;
                    requestParams.assessmentVersion = this.getAssessmentVersion;
                }
                else if (this.$route.query.assessment) {
                    requestParams.assessmentToken   = this.$route.query.assessment;
                    requestParams.assessmentVersion = this.getAssessmentVersion;
                }
                else if (this.referrerUrlParam === 'summary') {
                    requestParams.assessmentToken   = this.getAssessmentToken;
                    requestParams.assessmentVersion = this.getAssessmentVersion;
                }

                if (this.readMsitatValue !== null) {
                    requestParams.msitat = this.readMsitatValue;
                }

                // ----- Other params. -----
                // Specify a custom PDF template (template key).
                if (typeof additionalParams.template === "string"
                    && additionalParams.template.length > 0) {
                    requestParams.template = additionalParams.template;
                }
                // Language key for PDF translation.
                if (typeof additionalParams.translationLanguage === "string"
                        && additionalParams.translationLanguage.length > 0) {
                    requestParams.translationLanguage = additionalParams.translationLanguage;
                }
                // Destination phone number/email address/Threema ID for sending the PDF as message.
                if (typeof additionalParams.recipient !== "undefined") {
                    requestParams.recipient = additionalParams.recipient;
                }
                // `userAgrees` is used together with the `recipient` param. It's the value of the checkbox used
                // for the user to confirm that he/she agrees to use an external message provider to transfer
                // the E2E encrypted message.
                if (typeof additionalParams.userAgrees !== "undefined") {
                    requestParams.userAgrees = additionalParams.userAgrees;
                }

                return requestParams;
            },

            setSentFlag(){
                this.$store.commit('ScoringStore/setAssessmentSent', true);
            },

            setSentFlagFalse(){
                let that = this;
                setTimeout(function(){that.$store.commit('ScoringStore/setAssessmentSent', false);}, 2300);
            },

            sendAssessment() {
                this.$refs.form.validate();

                let requestParams = {
                    email: this.email,
                    sendEmailToUser: this.checkbox,
                    assessmentToken: this.getAssessmentToken,
                    assessmentVersion: this.getAssessmentVersion
                };
                if (this.readMsitatValue !== null) {
                    requestParams.msitat = this.readMsitatValue;
                }

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/sendAssessmentEmail', requestParams);

                axiosRequest.then(() => {
                    this.$store.commit('ScoringStore/setIsAssessmentSealed', true);

                    this.setSentFlag();
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            sendEmail: function() {
                this.isPdfTemplateListActive = false;
                this.isPhoneFormActive = false;
                this.isTranslatePdfFormActive = false;
                this.isEmailFormActive = !this.isEmailFormActive;
                this.$store.commit('ScoringStore/setMustShowSendAssessmentPopup', this.isEmailFormActive );
            },


            goToHomePage() {
                // This should not be used because going to the home page also triggers this store action.
                // If we use this there will be two calls made of the same endpoint
                this.$store.dispatch("ProductListStore/loadProductListPageData").then(() => {
                });
            },

            sendAssessmentPushHome() {
                this.sendAssessment()
                let that = this;
                    setTimeout(function() {
                        that.$router.push('/home');
                    }, 500);
            },

            goToPreviousUrl() {
                window.history.back();
            },

            goToScoringPage() {
                this.$router.push('/scoring');
            }
        },

        watch: {
            checkbox(newValue, oldValue) {
                if(newValue === true) {
                    let that = this;
                    setTimeout(function () {
                        let noOtherSymptom = document.getElementsByClassName('send-copy-section');
                        for (let i = 0; i < noOtherSymptom.length; i++) {
                            let iconCheckBox = noOtherSymptom[i].getElementsByClassName('icon--checkbox');

                            for (let j = 0; j < iconCheckBox.length; j++) {
                                iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                            }
                        }

                    }, 10)
                }
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .home-container.container.grid-list-xl {

        .body-home {

            margin-bottom: -60px;

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {

        li, .product-item {
            border-radius: 5px;
        }
    }

    .container.grid-list-xl .activate-product{

        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-block-border;
    }

    .icon-start-assessment {
        font-size: 36px;
    }

    .sponsors {
        border-radius: 5px;
    }

    #cont .footer.footer--fixed .footer-btn.home {
        padding-right: 12px;
        padding-left: 12px;
    }

    .phone-error{
        color: $color-error !important;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-share/AssessmentSharePage.vue